export const messages = {
  en: {
    serviceProvideManage: {
      search: {
        title: 'Search Conditions',
        serviceCode: 'Please enter service code',
        name: 'Please enter service name',
        queryModel: 'Please select implementation method'
      },
      list: {
        title: 'Service Provide Information',
        developService: 'Develop Service'
      },
      table: {
        provideId: 'Provide ID',
        name: 'Service Name',
        serviceCode: 'Service Code',
        params: 'Parameters',
        queryModel: 'Implementation Method',
        operation: 'Operation',
        remark: 'Remark'
      },
      options: {
        proc: 'Stored Procedure'
      },
      fetchError: 'Failed to fetch service provide list'
    }
  },
  zh: {
    serviceProvideManage: {
      search: {
        title: '查询条件',
        serviceCode: '请输入服务编码',
        name: '请输入服务名称',
        queryModel: '请选择实现方式'
      },
      list: {
        title: '服务提供信息',
        developService: '开发服务'
      },
      table: {
        provideId: '提供ID',
        name: '服务名称',
        serviceCode: '服务编码',
        params: '参数',
        queryModel: '实现方式',
        operation: '操作',
        remark: '备注'
      },
      options: {
        proc: '存储过程方式'
      },
fetchError: '获取服务提供列表失败'
    }
  },
  'zh-TW': {
    serviceProvideManage: {
      search: {
        title: '查詢條件',
        serviceCode: '請輸入服務編碼',
        name: '請輸入服務名稱',
        queryModel: '請選擇實現方式'
      },
      list: {
        title: '服務提供信息',
        developService: '開發服務'
      },
      table: {
        provideId: '提供ID',
        name: '服務名稱',
        serviceCode: '服務編碼',
        params: '參數',
        queryModel: '實現方式',
        operation: '操作',
        remark: '備註'
      },
      options: {
        proc: '存儲過程方式'
      },
      fetchError: '獲取服務提供列表失敗'
    }
  }
}